module.exports = __webpack_public_path__ + "img/aso.ef40ac7d.svg";